import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@fortawesome/fontawesome-free/css/all.css';
import FactCheckIcon from '@/components/Svgs/FactCheckIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#64c832',
        primary_sicredi: '#146E37',
        secondary_sicredi: '#1E3C0F',
        tertiary_sicredi: '#316915',
        secondary: '#ffffff',
        neutral: '#f5f5f5',
        neutral2: '#E6E6E6',
        error: '#e60050',
        success: '#64c832',
        warning: '#ffcd00',
        green: '#65CFAC',
        green3: '#b1e398',
        green4: '#ebf9e5',
        gray: '#8C8C8C',
        gray2: '#4D4D4D',
        red: '#FF0000',
        danger: '#E10000',
        sicredi_orange: '#FF5900',
        success2: '#107154',
        darker: '#1a1a1a',
      },
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      factCheckIcon: {
        component: FactCheckIcon,
      },
    },
  },
});
